import './App.css';
import EightBall from './EightBall';

const App = () => (
    <main className="App">
        <EightBall />
    </main>
);

export default App;
